import {createAsyncThunk, createSlice, isAnyOf, PayloadAction} from '@reduxjs/toolkit';
import {IErrorResult, IServerError} from '../../../../interface/Basic/api';
import {
    deleteAvatar,
    getAvatar,
    getCitizenship,
    getExternalAccounts,
    getIdentityCard,
    getIdentityCardType,
    getSex,
    getSnils,
    getUser,
    patchIdentityCard,
    patchPerson,
    patchSnils,
    postAvatar,
    repeatCode,
} from './api';
import {
    ChangeDataModalInit,
    IAccountState,
    IChangeDataModal,
    IForeignPassport,
    IPassport,
    IPersonalInfo,
    ISocialNumber
} from "../../../../interface/Passport/Account/frontend";
import {
    CitizenshipArray,
    ForeignPassport,
    ICitizenship,
    IdentityCard,
    IdentityCardType,
    IdentityCardTypes,
    IGetAvatarResponse,
    IGetCitizenshipResponse,
    IGetExternalResponse,
    IGetIdentityCardResponse,
    IGetIdentityCardTypeResponse,
    IGetSnilsResponse,
    IIdentityCardTypeRequest,
    IInitiateDataChangeResult,
    InitiateDataChangeResultModel,
    IPersonResponse,
    IRepeatCodeProps,
    ISex,
    ISexResponse,
    ISnilsRequest,
    IUserResponse,
    Passport,
    Person,
    Sex,
    Snils,
    User
} from "../../../../interface/Passport/Account/backend";
import moment from "moment";
import {IdentityCardTypeEnum} from "../../../../enum/identityCardTypeEnum";
import {IForeignPassportInput, IPassportInput} from "../Modals/ChangePassport";

export const GetUser = createAsyncThunk<IUserResponse, undefined, { rejectValue: IErrorResult }>
('getUser', (data, thunkAPI) => getUser()
    .then(resolve => resolve)
    .catch((error: IServerError) => {
        return thunkAPI.rejectWithValue(error.response.data.error);
    }))

export const GetSnils = createAsyncThunk<IGetSnilsResponse, undefined, { rejectValue: IErrorResult }>
('getSnils', (data, thunkAPI) => getSnils()
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const GetExternalAccounts = createAsyncThunk<IGetExternalResponse, undefined, { rejectValue: IErrorResult }>
('getExternalAccounts', (data, thunkAPI) => getExternalAccounts()
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))


export const PatchSnils = createAsyncThunk<IGetSnilsResponse, ISnilsRequest, { rejectValue: IErrorResult }>
('postSnils', (data, thunkAPI) => patchSnils(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))


export const GetIdentityCard = createAsyncThunk<IGetIdentityCardResponse, undefined, { rejectValue: IErrorResult }>
('getIdentityCard', (data, thunkAPI) => getIdentityCard()
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const PatchIdentityCard = createAsyncThunk<IGetIdentityCardResponse, IPassportInput | IForeignPassportInput, {
    rejectValue: IErrorResult
}>
('patchIdentityCard', (data, thunkAPI) => patchIdentityCard(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const GetCitizenship = createAsyncThunk<IGetCitizenshipResponse, undefined, { rejectValue: IErrorResult }>
('getCitizenshipCard', (data, thunkAPI) => getCitizenship()
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const GetIdentityCardType = createAsyncThunk<IGetIdentityCardTypeResponse, IIdentityCardTypeRequest | undefined, {
    rejectValue: IErrorResult
}>
('getIdentityCardType', (data, thunkAPI) => getIdentityCardType(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))


export const GetSex = createAsyncThunk<ISexResponse, undefined, { rejectValue: IErrorResult }>(
    'getSex', (data, thunkAPI) => getSex()
        .then(resolve => resolve)
        .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const PatchPerson = createAsyncThunk<IPersonResponse, IPersonalInfo, { rejectValue: IErrorResult }>(
    'patchPerson', (data, thunkAPI) => patchPerson(data)
        .then(resolve => resolve)
        .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const GetAvatar = createAsyncThunk<IGetAvatarResponse, undefined, { rejectValue: IErrorResult }>
('getAvatar', (data, thunkAPI) => getAvatar()
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const PostAvatar = createAsyncThunk<IGetAvatarResponse, FormData, { rejectValue: IErrorResult }>
('postAvatar', (data, thunkAPI) => postAvatar(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const DeleteAvatar = createAsyncThunk<undefined, undefined, { rejectValue: IErrorResult }>
('deleteAvatar', (data, thunkAPI) => deleteAvatar()
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const RepeatCode = createAsyncThunk<IInitiateDataChangeResult, IRepeatCodeProps, { rejectValue: IErrorResult }>
('RepeatCode', (data, thunkAPI) => repeatCode(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

// const json = `{"data": [
//         {
//             "name": "Сбер ID",
//             "connected": false,
//             "url": null,
//             "message": {
//                 "success": null,
//                 "error": null
//             },
//             "sber": {
//                 "client_id": "F012F695-EE04-C8F1-E481-85AF652BCEAE",
//                 "state": "0269b68796e3c29e3c89b1c87b2f2f01",
//                 "nonce": "4cb13aeb8c1a46539383f798ddaab12a436bafe4f2fbe7afaaa5fca90d345713099bcef6dd4979853221d7d266e2faa567f01adc1d8183dc753019e5d5bd5972",
//                 "redirect_uri": "https://local-id-api.rudn.ru/external-api/v1/verify/sberid",
//                 "scope": "openid profile email",
//                 "response_type": "code",
//                 "client_type": "PRIVATE"
//             }
//         },
//         {
//             "name": "Паспорт",
//             "connected": true,
//             "url": "https://prod-id.rudn.ru/sign-in?state=56a2d1bb18265f7338bd08f6fe864e7b&nonce=dc69654c798ee6c16aa358811f51b3499c7f9cbe200235be1a57583e5bbfebfb1e94b248bf6c4be81fffeaec6090718e97969c130e1f6a0947073b79ccd412c6&scope=openid%20profile%20email&response_type=code&approval_prompt=auto&redirect_uri=https%3A%2F%2Flocal-id-api.rudn.ru%2Fexternal-api%2Fv1%2Fverify%2Fprodid&client_id=e35905fd-3c63-4d58-bd7a-d4186f53cae4",
//             "message": {
//                 "success": null,
//                 "error": null
//             }
//         }
//     ],
//     "error": null,
//     "trace": null
// }`

const initialState: IAccountState = {
    personalInfo: {
        name: '',
        surname: '',
        patronymic: null,
        birthdate: null,
        sex_id: null,
        sex: null
    },
    socialNumber: null,
    passport: null,
    foreign_passport: null,
    gender: [],
    citizenship: [],
    identityCardType: null,
    identityCardTypes: [],
    error: {},
    avatar: null,
    phone: null,
    email: null,
    smsPending: false,
    codePending: false,
    retryAfter: null,
    isSecurityInputSend: false,
    isCodeRight: false,
    passwordDate: null,
    addAvatar: false,
    works: null,
    educations: null,
    worksPending: false,
    educationsPending: false,
    tabClick: false,
    isFetching: false,
    needUpdate: false,
    changeDataModal: ChangeDataModalInit,
    externalAccountsData: null,
}

export const slice = createSlice({
    name: 'account',
    initialState,
    reducers:
        {
            setPersonalInfo(state, action: PayloadAction<IPersonalInfo>) {
                state.personalInfo = action.payload
            },
            setForeignPassport(state, action: PayloadAction<IPassport>) {
                state.passport = action.payload
            },
            setPassport(state, action: PayloadAction<IForeignPassport>) {
                state.foreign_passport = action.payload
            },
            setIdentityCardType(state) {
                state.identityCardType = null
            },
            setSocialNumber(state, action: PayloadAction<ISocialNumber>) {
                state.socialNumber = action.payload
            },
            addError(state, action: PayloadAction<{ key: string, value: string }>) {
                state.error[action.payload.key] = action.payload.value
            },
            cleanError(state, action: PayloadAction<string>) {
                delete state.error[action.payload]
            },
            cleanAllErrors(state) {
                state.error = {}
            },
            setAddAvatar(state, action: PayloadAction<boolean>) {
                state.addAvatar = action.payload
            },
            setEducations(state) {
                state.educationsPending = true
            },
            setWorks(state) {
                state.worksPending = true
            },
            onTabClick(state) {
                state.tabClick = !state.tabClick
            },
            setNeedUpdate(state, action: PayloadAction<boolean>) {
                state.needUpdate = action.payload
            },
            resetRetryAfter(state) {
                if (state.changeDataModal.dataForChange) {
                    state.changeDataModal.dataForChange.retry_after = null
                }
            },
            setChangeDataModal(state, action: PayloadAction<IChangeDataModal>) {
                state.changeDataModal = action.payload
            },
            setChangeDataModalSuccess(state,action) {
                state.changeDataModal.success = action.payload;
            },
            setChangeDataModalDataForChange(state,action) {
                state.changeDataModal.dataForChange = action.payload
            },
            setSmsPending(state,action) {
                state.smsPending=action.payload;
            },
        },
    extraReducers: (builder) => {
        builder.addCase(GetUser.fulfilled, (state, action) => {
            const user = User.parse(action.payload.data)
            state.personalInfo = {
                ...state.personalInfo,
                name: user.person.name,
                surname: user.person.surname,
                patronymic: user.person.patronymic,
                birthdate: user.person.birthdate ? moment(user.person.birthdate) : null,
                sex_id: user.person.sex_id,
                sex: user.person.sex
            }
            state.phone = user.phone
            state.email = user.email
        })

        builder.addCase(PatchPerson.pending, (state) => {
            state.isFetching = true
        })
        builder.addCase(PatchPerson.rejected, (state) => {
            state.isFetching = false
        })
        builder.addCase(PatchPerson.fulfilled, (state, action) => {
            state.isFetching = false
            state.needUpdate = true
            const person = Person.parse(action.payload.data)
            state.personalInfo = {
                ...state.personalInfo,
                name: person.name,
                surname: person.surname,
                patronymic: person.patronymic,
                birthdate: person.birthdate ? moment(person.birthdate) : null,
                sex_id: person.sex_id,
                sex: person.sex
            }
        })

        builder.addCase(GetSex.fulfilled, (state, action) => {
            const genders = action.payload.data
            state.gender = genders.map((item: ISex) => Sex.parse(item));
        })
        builder.addCase(GetIdentityCard.pending, (state) => {
            state.isFetching = true
        })
        builder.addCase(GetIdentityCard.rejected, (state) => {
            state.isFetching = false
        })
        builder.addCase(GetIdentityCard.fulfilled, (state, action) => {
            const data = IdentityCard.parse(action.payload.data)
            switch (data.identity_card_type_id) {
                case IdentityCardTypeEnum.Passport:
                    const data = Passport.parse(action.payload.data)
                    state.passport = {
                        ...state.passport,
                        citizenship: {
                            id: data.citizenship.id,
                            name: data.citizenship.name || ''
                        },
                        citizenship_id: data.citizenship_id,
                        department_code: data.department_code || '',
                        id: data.id,
                        identityCardType: {
                            id: data.identityCardType.id,
                            name: data.identityCardType.name
                        },
                        identity_card_type_id: data.identity_card_type_id,
                        is_verified: data.is_verified,
                        issued_at: moment(data.issued_at),
                        issued_by: data.issued_by || '',
                        number: data.number,
                        person_id: data.person_id,
                        series: data.series,
                        outdated: moment('06.05.2022'),
                        isOutdated: moment(data.issued_at).diff(moment(data.issued_at)) < 0
                    }
                    break;
                case IdentityCardTypeEnum.ForeignPassport:
                    const foreignPassport = ForeignPassport.parse(action.payload.data)
                    state.foreign_passport = {
                        ...state.foreign_passport,
                        citizenship: {
                            id: foreignPassport.citizenship.id,
                            name: foreignPassport.citizenship.name || ''
                        },
                        citizenship_id: foreignPassport.citizenship_id,
                        id: foreignPassport.id,
                        identityCardType: {
                            id: foreignPassport.identityCardType.id,
                            name: foreignPassport.identityCardType.name
                        },
                        identity_card_type_id: foreignPassport.identity_card_type_id,
                        is_verified: foreignPassport.is_verified,
                        issued_at: moment(foreignPassport.issued_at),
                        number: foreignPassport.number,
                        person_id: foreignPassport.person_id,
                        expires_at: moment(foreignPassport.expires_at),
                        outdated: moment(foreignPassport.expires_at),
                        isOutdated: moment(foreignPassport.expires_at).diff(moment(foreignPassport.issued_at)) < 0
                    }
            }
            state.isFetching = false
        })

        builder.addCase(GetSnils.fulfilled, (state, action) => {
            const data = Snils.parse(action.payload.data)
            state.socialNumber = {
                ...state.socialNumber,
                value: data.value,
                is_verified: data.is_verified
            }
        })

        builder.addCase(GetExternalAccounts.fulfilled, (state, action) => {
            state.externalAccountsData = action.payload
        })

        builder.addCase(GetExternalAccounts.pending, (state) => {
            state.isFetching = true
        })
        builder.addCase(GetExternalAccounts.rejected, (state) => {
            state.isFetching = false
        })

        builder.addCase(GetCitizenship.fulfilled, (state, action) => {
            const citizenship = CitizenshipArray.parse(action.payload.data)
            state.citizenship = citizenship.map((item: ICitizenship) => ({...item, name: item.name ?? ' - '}));
        })

        builder.addCase(GetIdentityCardType.pending, (state) => {
            state.isFetching = true
        })

        builder.addCase(GetIdentityCardType.fulfilled, (state, action) => {
            const identityCard = IdentityCardType.parse(action.payload.data[0])
            state.identityCardType = identityCard.id
            state.identityCardTypes = IdentityCardTypes.parse(action.payload.data)
            state.isFetching = false
        })

        builder.addCase(PatchSnils.pending, (state) => {
            state.isFetching = true
        })
        builder.addCase(PatchSnils.rejected, (state) => {
            state.isFetching = false
        })
        builder.addCase(PatchSnils.fulfilled, (state, action) => {
            state.isFetching = false
            state.needUpdate = true
            const data = Snils.parse(action.payload.data)
            state.socialNumber = {
                ...state.socialNumber,
                value: data.value,
                is_verified: data.is_verified
            }
        })

        builder.addCase(PatchIdentityCard.pending, (state) => {
            state.isFetching = true
        })
        builder.addCase(PatchIdentityCard.rejected, (state) => {
            state.isFetching = false
        })

        builder.addCase(PatchIdentityCard.fulfilled, (state, action) => {
            state.isFetching = false
            state.needUpdate = true
            const data = IdentityCard.parse(action.payload.data)
            switch (data.identity_card_type_id) {
                case IdentityCardTypeEnum.Passport:
                    state.foreign_passport = null
                    const data = Passport.parse(action.payload.data)
                    state.passport = {
                        ...state.passport,
                        citizenship: {
                            id: data.citizenship.id,
                            name: data.citizenship.name || ''
                        },
                        citizenship_id: data.citizenship_id,
                        department_code: data.department_code || '',
                        id: data.id,
                        identityCardType: {
                            id: data.identityCardType.id,
                            name: data.identityCardType.name
                        },
                        identity_card_type_id: data.identity_card_type_id,
                        is_verified: data.is_verified,
                        issued_at: moment(data.issued_at),
                        issued_by: data.issued_by || '',
                        number: data.number,
                        person_id: data.person_id,
                        series: data.series,
                        outdated: moment(data.issued_at),
                        isOutdated: moment(data.issued_at).diff(moment(data.issued_at)) < 0
                    }
                    break;
                case IdentityCardTypeEnum.ForeignPassport:
                    state.passport = null
                    const foreignPassport = ForeignPassport.parse(action.payload.data)
                    state.foreign_passport = {
                        ...state.foreign_passport,
                        citizenship: {
                            id: foreignPassport.citizenship.id,
                            name: foreignPassport.citizenship.name || ''
                        },
                        citizenship_id: foreignPassport.citizenship_id,
                        id: foreignPassport.id,
                        identityCardType: {
                            id: foreignPassport.identityCardType.id,
                            name: foreignPassport.identityCardType.name
                        },
                        identity_card_type_id: foreignPassport.identity_card_type_id,
                        is_verified: foreignPassport.is_verified,
                        issued_at: moment(foreignPassport.issued_at),
                        number: foreignPassport.number,
                        person_id: foreignPassport.person_id,
                        expires_at: moment(foreignPassport.expires_at),
                        outdated: moment(foreignPassport.expires_at),
                        isOutdated: moment(foreignPassport.expires_at).diff(moment(foreignPassport.issued_at)) < 0
                    }
            }
        })


        builder.addCase(GetAvatar.fulfilled, (state, action) => {
            const avatar = action.payload.data
            if (avatar)
                state.avatar = {
                    id: avatar.id,
                    path: avatar.path
                }
        })

        builder.addCase(PostAvatar.fulfilled, (state, action) => {
            const avatar = action.payload.data
            if (avatar)
                state.avatar = {
                    ...state.avatar,
                    id: avatar.id,
                    path: avatar.path
                }
            state.addAvatar = false
        })

        builder.addCase(DeleteAvatar.fulfilled, (state) => {
            state.avatar = null
        })

        builder.addCase(RepeatCode.fulfilled, (state, action) => {
            state.changeDataModal.dataForChange = InitiateDataChangeResultModel.parse(action.payload.data)
        })

        // builder.addMatcher(isAnyOf(
        //     InitiateChangeData.rejected,
        // ), (state, action) => {
        //     if (!action.meta.aborted) {
        //         state.smsPending = false
        //     }
        // })

        builder.addMatcher(isAnyOf(
            PatchPerson.rejected,
            PatchSnils.rejected,
            PatchIdentityCard.rejected,
            RepeatCode.rejected,
        ), (state, action) => {
            if (action.payload?.fields) {
                Object.entries(action.payload.fields).forEach((item) => {
                    state.error[item[0]] = item[1] ? item[1][0] : ''
                })
            }
        })
    }
})

export const {
    setIdentityCardType,
    cleanError,
    addError,
    cleanAllErrors,
    setAddAvatar,
    setEducations,
    setWorks,
    onTabClick,
    setNeedUpdate,
    resetRetryAfter,
    setChangeDataModal,
    setChangeDataModalSuccess,
    setChangeDataModalDataForChange,
    setSmsPending
} = slice.actions;

export default slice.reducer;
